import(/* webpackMode: "eager" */ "/opt/lampp/htdocs/maha6v2/app/[locale]/(auth)/register/page.tsx");
